import { Component } from '@angular/core';
import { PwaInstallService } from '../../../../app/services/base/pwa-install.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'fury-app-install-dialog',
  templateUrl: './app-install-dialog.component.html',
  styleUrls: ['./app-install-dialog.component.scss'],
})

export class AppInstallDialogComponent {

  protected readonly environment = environment;

  constructor(
    public pwaInstallService: PwaInstallService,
  ) {
  }
}
